const Events = {
    LOAD_INITIAL_DATA_LOADING: 'REDUX_THUNK_LOAD_INITIAL_DATA_LOADING',
    LOAD_INITIAL_DATA_SUCCESS: 'REDUX_THUNK_LOAD_INITIAL_DATA_SUCCESS',
    LOAD_INITIAL_DATA_ERROR: 'REDUX_THUNK_LOAD_INITIAL_DATA_ERROR',
    LOAD_DISTANT_DATA_SUCCESS: 'REDUX_THUNK_LOAD_DISTANT_DATA_SUCCESS',
    ADD_BUNDLE: 'ADD_BUNDLE',
    EDIT_BUNDLE: 'EDIT_BUNDLE',
    SORT_BUNDLE: 'SORT_BUNDLE',
    DELETE_BUNDLE: 'DELETE_BUNDLE',
    ADD_CHARACTER: 'ADD_CHARACTER',
    EDIT_CHARACTER: 'EDIT_CHARACTER',
    DELETE_CHARACTER: 'DELETE_CHARACTER',
    ADD_MOVIE: 'ADD_MOVIE',
    EDIT_MOVIE: 'EDIT_MOVIE',
    DELETE_MOVIE: 'DELETE_MOVIE',
    ADD_SOUND: 'ADD_SOUND',
    EDIT_SOUND: 'EDIT_SOUND',
    SORT_SOUND: 'SORT_SOUND',
    DELETE_SOUND: 'DELETE_SOUND',
    SYNC_BUNDLE: 'SYNC_BUNDLE',
    UPDATE_BLACK_LIST: 'UPDATE_BLACK_LIST',
    LOADING: 'LOADING',
    LOADED: 'LOADED'
};

export default Events;